var BASWebServices;
(function (BASWebServices) {
    var HintController = (function () {
        function HintController($scope, $rootScope, $timeout, hs) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.hs = hs;
            $scope.hintc = this;
            this.$rootScope.$on('CLOSE_HINT_IF_STIL_OPENED', function () {
                $timeout(function () {
                    var btnClose = document.getElementById('hintCloseButton');
                    angular.element(btnClose).triggerHandler('click');
                }, 1000);
            });
            this.$scope.HINT_ENTRY = this.hs.setRandomEntryToScope();
        }
        HintController.prototype.getAnotherHintFromCache = function () {
            this.$scope.HINT_ENTRY = this.hs.setRandomEntryToScope();
        };
        return HintController;
    }());
    BASWebServices.HintController = HintController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=HintController.js.map